window.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('header')

	let previousScrollTop = 0

	if (header) {
		const hamburger = header.querySelector('.hamburger')

		window.addEventListener('scroll', e => {
			let currentScrollTop = window.scrollY

			if (previousScrollTop - currentScrollTop < 0) {
				header.classList.add('scrolling-down')
				hamburger.classList.remove('open')
			} else {
				header.classList.remove('scrolling-down')
			}

			if (currentScrollTop > 150) {
				header.classList.add('scrolled-down')
			} else {
				header.classList.remove('scrolled-down')
			}

			if (currentScrollTop > window.innerHeight * 1.5) {
				header.classList.add('show-logo')
			} else {
				header.classList.remove('show-logo')
			}

			previousScrollTop = currentScrollTop
		})

		hamburger?.addEventListener('click', e => {
			hamburger.classList.toggle('open')
		})

		window.addEventListener('click', e => {
			if (!e.target.closest('header')) {
				hamburger.classList.remove('open')
			}
		})

		// Listeners for clicks on chevrons to open dropdowns
		const parents = document.querySelectorAll(
			'header nav .menu-item-has-children'
		)
		parents.forEach(parent => {
			parent.addEventListener('click', e => {
				e.preventDefault()
				parent.classList.toggle('open')
			})
			var childAnchors = parent.querySelectorAll('a');
			childAnchors.forEach(childAnchor => {
				childAnchor.addEventListener('click', e => {
					e.stopPropagation();
				})
			})
		})
	}
})
